import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductCard } from 'src/app/model/product-card';
import { ProductDto } from 'src/app/model/ProductDto';


@Component({
  selector: 'ms-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  @Input() product!: ProductCard;

  constructor(
    private router: Router,
    private navigateService: NavigateService
  ) { }

  ngOnInit(): void {

  }

  public openFamily(){
    let productDto = new ProductDto(this.product.ProductCode, this.product.ProductCode, 'last');
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(productDto))
    this.router.navigate(['/products-download/product-viewer']);
  }

  public navigate(url: string, params?: object ) {
    params['productKey'] = this.product.ProductCode
    this.router.navigate([url], { queryParams: params});
  }
}
